export default "__VITE_ASSET__ZAqTHDLt__"